import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '../components';
import { getAudience, getScopes } from './auth0Utils';

export const Auth0ProviderWithHistory = ({ children }: {
  children: any;
}) => {
  const organization = useOrganization()
  const navigate = useNavigate()

  const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
  const redirectUri = `${window.location.origin}/login`

  const onRedirectCallback = (appState: any) => {
    console.log('[auth0] onRedirectCallback() appState', appState)
    navigate(appState?.returnTo || window.location.pathname + window.location.search);
  };

  // Properties needed to allow mfa.  Also check the boxes in auth0 ui.
  let scope = getScopes(organization.MfaRequired)
  const audience = getAudience(organization.MfaRequired)

  const auth0Config: Auth0ProviderOptions = {
    domain,
    clientId,
    redirectUri,
    audience,
    scope,
    organization: organization.Auth0OrganizationId
  }

  return (
    <Auth0Provider {...auth0Config} onRedirectCallback={onRedirectCallback}>
      {children}
      {/* <StoreAuthenticated/> */}
    </Auth0Provider>
  );
};


// TODO [CD-738]: add this back in later with a remember me option in the login form
// const StoreAuthenticated = () => {
//   // IMPROVE (maybe): Grab the user's name here and store that in local storage
//   // and the landing page could use it to say "WELCOME BACK TODD!"
//   const { isAuthenticated, user } = useAuth0()
//   const [lastAuthenticatedEmailAddress, setLastAuthenticatedEmailAddress] = useLocalStorage('lastAuthenticatedEmailAddress', '')

//   useEffect(() => {
//     if (isAuthenticated && user?.email && user.email !== lastAuthenticatedEmailAddress) {
//       setLastAuthenticatedEmailAddress(user.email)
//     }
//   }, [ isAuthenticated, lastAuthenticatedEmailAddress, setLastAuthenticatedEmailAddress, user?.email ]);

//   return null;
// }
